import { Logger } from 'ia-react-core/~/utils/log/createLogger';

const loggerRegistry: Record<string, Logger> = {};

export default loggerRegistry;
